import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ConferenceForm from 'views/admin/conference/ConferenceForm'
import ConferenceListing from 'views/admin/conference/ConferenceListing'

const Conference = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <ConferenceListing />
      </Route>
      <Route exact path={`${path}/new`}>
        <ConferenceForm />
      </Route>
      <Route exact path={`${path}/edit/:conferenceId`}>
        <ConferenceForm />
      </Route>
    </Switch>
  )
}

export default Conference
